import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Bredcom from '../components/Bredcom/Bredcom';
import Footer from '../components/Footer/Footer';

function Onama () {
    return (
        <>
        <Navbar/>
        <Bredcom title="Početna" subtitle="O nama" />
        <Footer />
        </>
    )
}
export default Onama;